<template lang="pug">
Dialer
</template>

<script>
import Dialer from "./components/Dialer";

export default {
  name: "App",
  components: {
    Dialer
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100vh;
}
</style>
